import React from 'react';
import MenuItemAnchor from './MenuItemAnchor';
import startsWith from 'lodash/startsWith';

function Toolbar(props) {
    const isActive = startsWith(window.location.pathname, '/hike/');

    return (<a {...props} href="/hike/" style={{
        ...props.style,
        borderBottomWidth: isActive ? 3 : 0,
        marginTop: isActive ? 3 : 0,
    }}>
        {gettext('Hikes')}
    </a>);
}

function HamburgerMenu(props) {
    return (<MenuItemAnchor {...props} href="/hike/">
        {gettext('Hikes')}
    </MenuItemAnchor>);
}

export default { Toolbar, HamburgerMenu };
